define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext", "../../utils/LookupDataSources"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, UserContext, LookupDataSources) {
    "use strict";
    var CustomersContactsReport = /** @class */ (function () {
        function CustomersContactsReport() {
            this.canExport = ko.observable(UserContext.hasAccess("Admin,CustomersContactsReport.Export"));
            this.isAdmin = ko.observable(UserContext.hasAccess("Admin,Reports.Admin"));
        }
        CustomersContactsReport.prototype.init = function () {
            var self = this;
            $("#page-title").text("Customers Contacts Report");
            tools.ajaxGet({
                url: "/Reports/GetCustomersContactsLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.initGrid(data.Data.GridStructures.CustomersContactsReportStructure);
                        ko.applyBindings(self, document.getElementById("main-container"));
                    }
                    else {
                        log.error(data.Error);
                    }
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CustomersContactsReport.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblCustomersContactsReportKendo";
            var columns = gridStructure.columns;
            //add actions column
            /*if (UserContext.hasAccess("Admin")) {
                var actions = {
                    field: "",
                    width: "100px",
                    template(dataItem) {
                        var html = "";
    
                        html += `<a class="btn btn-sm btn-yellow btn-edit" href="/Customers/Edit/${dataItem.Id}"><i class="fa fa-edit "></i>&nbsp;View</a>`;
    
                        return html;
                    }
                };
                columns.push(actions);
            }*/
            self.reportTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Reports/GetCustomersContactsData",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.multipleCustomersSelector) {
                                    data.customers = self.multipleCustomersSelector.value().join(",");
                                }
                                if (self.multipleTagsSelector) {
                                    data.tags = self.multipleTagsSelector.value().join(",");
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    schema: {
                        model: gridStructure.model
                    },
                    aggregate: gridStructure.aggregate,
                    serverAggregates: true
                },
                gridOptions: {
                    toolbar: kendo.template($("#customersNotesReport-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                },
                enableExport: {
                    entityName: "CustomersContactsReport",
                    title: "Customers Contacts Report",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: self.canExport()
                },
                gridId: gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.reportTable.initGrid(gridOptions);
            var lookupDataSources = new LookupDataSources();
            var tagsDS = lookupDataSources.createLookupDataSource("ContactTags");
            var customersDS = lookupDataSources.createLookupDataSource("Customers");
            self.multipleCustomersSelector = $("#filterByCustomerInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                placeholder: "All Customers",
                dataTextField: "Text",
                dataValueField: "Id",
                autoClose: false,
                tagMode: "single",
                dataSource: customersDS,
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    $(window).trigger("resize");
                    self.reportTable.refresh();
                }
            }).data("kendoMultiSelect");
            self.multipleTagsSelector = $("#filterByTagInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                placeholder: "All Tags",
                dataTextField: "Text",
                dataValueField: "Id",
                autoClose: false,
                tagMode: "single",
                dataSource: tagsDS,
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    $(window).trigger("resize");
                    self.reportTable.refresh();
                }
            }).data("kendoMultiSelect");
        };
        CustomersContactsReport.prototype.clearFilter = function () {
            var self = this;
            self.multipleTagsSelector.value([]);
            //self.multipleTagsSelector.trigger("change");
            self.multipleCustomersSelector.value([]);
            //self.multipleTagsSelector.trigger("change");
        };
        CustomersContactsReport.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.reportTable.exportTo();
            }
        };
        return CustomersContactsReport;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Reports/CustomersContactsReportIndex")) {
            log.log("Initialize CustomersContactsReportIndex list");
            $(function () {
                (new CustomersContactsReport()).init();
            });
        }
    }, 0);
    return CustomersContactsReport;
});
//# sourceMappingURL=CustomersContactsReport.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/customersContactsReport.js
// module id = 265
// module chunks = 2